<template>
  <div>
    <time-line class="left fts-history-timeline" type="simple">
      <time-line-item v-for="item in ftsHistory" :key="item.id" class="timeline-inverted" badgeType="primary"
                      badgeIcon="nc-icon fas fa-cog">
        <div slot="content">
          <div class="mb-2">
            <span class="mr-2 destination" v-if="item.incoming === false">&#8594;</span>
            <span class="mr-2 destination" v-else>&#8592;</span>
            <span class="mr-2 preparation-datetime">{{ convertDate(item.preparation_datetime) }}</span>
            <span class="mr-2 read-fts-message" @click="readFtsMessage(item.id)"><b>{{ item.code }}</b></span>
            <span class="mr-2 customs-message" :title="convertCustomsMessages(item.code)"><small>{{ convertCustomsMessages(item.code) }}</small></span>
          </div>
          <div v-if="item.children && item.children.length">
            <div v-for="item2 in item.children" :key="item2.id" style="margin-left: 25px;">
              <div class="mb-2">
                <span class="mr-2 destination" v-if="item2.incoming === false">&#8594;</span>
                <span class="mr-2 destination" v-else>&#8592;</span>
                <span class="mr-2 preparation-datetime">{{ convertDate(item2.preparation_datetime) }}</span>
                <span class="mr-2 read-fts-message" @click="readFtsMessage(item2.id)"><b>{{ item2.code }}</b></span>
                <span class="mr-2 customs-message" :title="convertCustomsMessages(item2.code)"><small>{{ convertCustomsMessages(item2.code) }}</small></span>
              </div>
              <div v-if="item2.children && item2.children.length">
                <div v-for="item3 in item2.children" :key="item3.id" style="margin-left: 25px;">
                  <div class="mb-2">
                    <span class="mr-2 destination" v-if="item3.incoming === false">&#8594;</span>
                    <span class="mr-2 destination" v-else>&#8592;</span>
                    <span class="mr-2 preparation-datetime">{{ convertDate(item3.preparation_datetime) }}</span>
                    <span class="mr-2 read-fts-message" @click="readFtsMessage(item3.id)"><b>{{ item3.code }}</b></span>
                    <span class="mr-2 customs-message" :title="convertCustomsMessages(item3.code)"><small>{{ convertCustomsMessages(item3.code) }}</small></span>
                  </div>
                  <div v-if="item3.children && item3.children.length">
                    <div v-for="item4 in item3.children" :key="item4.id" style="margin-left: 25px;">
                      <div class="mb-2">
                        <span class="mr-2 destination" v-if="item4.incoming === false">&#8594;</span>
                        <span class="mr-2 destination" v-else>&#8592;</span>
                        <span class="mr-2 preparation-datetime">{{ convertDate(item4.preparation_datetime) }}</span>
                        <span class="mr-2 read-fts-message" @click="readFtsMessage(item4.id)"><b>{{ item4.code }}</b></span>
                        <span class="mr-2 customs-message" :title="convertCustomsMessages(item4.code)"><small>{{ convertCustomsMessages(item4.code) }}</small></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </time-line-item>
    </time-line>
  </div>
</template>
<script>
import moment from 'moment'
import TimeLine from './TimeLine/TimeLine'
import TimeLineItem from './TimeLine/TimeLineItem'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  components: {
    TimeLine,
    TimeLineItem
  },
  data () {
    return {}
  },
  mounted () {

  },
  computed: {
    ...mapState(
      {
        ftsHistory: state => state.piportalApiSearch.ftsHistory,
        customsMessages: state => state.piportalApiSearch.customsMessages
      }
    )
  },
  props: ['number'],
  methods: {
    ...mapActions([
      'loadFtsExchangeHistory',
      'loadCustomsMessages'
    ]),
    ...mapMutations([]),
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    convertDate (date) {
      return this.moment(date).format('DD.MM.YYYY HH:mm')
    },
    convertCustomsMessages (code) {
      return this.customsMessages.filter(message => message.code === code)[0].name
    },
    readFtsMessage (id) {
      const url = '/api/private/v3.0/packages/' + this.number + '/messages/' + id + '/view/'
      const newWin = window.open(url)
      newWin.onload = function () {
        const css = 'div.page { width: 297mm !important; margin: 10px auto !important; }'
        const head = newWin.document.head || newWin.document.getElementsByTagName('head')[0]
        const style = newWin.document.createElement('style')
        head.appendChild(style)
        style.appendChild(newWin.document.createTextNode(css))
      }
    }
  }
}
</script>
<style scoped>
  .fts-history-timeline .card-timeline .timeline {
    padding: 0 !important;
  }

  .fts-history-timeline .card-timeline .timeline > li {
    margin-bottom: 0px !important;
  }

  .fts-history-timeline .card-timeline .timeline > li > div.timeline-panel {
    margin-bottom: 10px !important;
  }

  .customs-message {
    cursor: default;
  }

  .read-fts-message {
    cursor: pointer;
    color: #1b7fcc;
  }

  .read-fts-message:hover {
    text-decoration: underline;
  }

  .card {
    background-color: #ECEFF1;
  }
</style>
